import { useNavigate } from "react-router-dom";
import { ArrowRight, ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { CoTile, StageTrack } from "./parts";
import { appStatus, stageSteps, byGroup, TONE } from "./portal";

export function HomeApplications({ apps, interviews }) {
  const nav = useNavigate();
  const rows = apps.map((a) => ({ a, s: appStatus(a, interviews) })).sort(byGroup);
  return (
    <section data-testid="home-applications" aria-labelledby="home-apps-title">
      <header className="flex items-center justify-between mb-3">
        <h2 id="home-apps-title" className="text-[17px] font-semibold">Your applications · {apps.length}</h2>
        <button onClick={() => nav("/candidate/applications")} className="text-sm text-primary hover:underline inline-flex items-center gap-1" data-testid="home-apps-view-all">
          View all <ArrowRight className="h-3.5 w-3.5" />
        </button>
      </header>
      <ul className="space-y-3 hs-stagger">
        {rows.slice(0, 5).map(({ a, s }) => (
          <li key={a.id}>
            <button onClick={() => nav(s.to || `/candidate/applications?open=${a.id}`)} data-testid={`home-app-${a.id}`}
              className="hs-card w-full text-left px-4 sm:px-5 py-4 flex items-center gap-4 hover:border-foreground/20 transition-colors">
              <CoTile name={a.company_name || a.job?.title} className="hidden sm:flex" />
              <span className="min-w-0 flex-1 sm:flex-none sm:w-[30%] leading-tight">
                <span className="block font-semibold truncate">{a.job?.title}</span>
                <span className="hidden sm:block text-sm text-muted-foreground truncate">{a.company_name}</span>
                <span className={cn("sm:hidden block text-[13px] mt-0.5", TONE[s.tone])}>{s.brief}</span>
              </span>
              <StageTrack done={stageSteps(a)} muted={s.group === "closed"} className="hidden sm:grid flex-1 min-w-[220px] max-w-[300px]" />
              <span className={cn("hidden sm:block ml-auto w-[160px] shrink-0 text-sm font-medium text-right truncate", TONE[s.tone])} data-testid={`home-app-status-${a.id}`}>{s.brief}</span>
              <ChevronRight className="sm:hidden h-4 w-4 text-muted-foreground shrink-0" />
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}
